//@flow

import React from 'react';

import Span from '../PaymentSummarySpan';

/**
 * This component is used in **Summary** section of the **Payment** page of
 * Lodge Details @see /screens/Lodge/Payment/Summary
 * Trek          @see /screens/Trek/Common/Summary
 * Cart          @see /screens/Cart/CartPayment
 */

type Props = {
  discount: string,
  basePrice: string,
  grandTotal: string,
  currency: string,
  additionalCost: ?string,
  purchaseAmount: ?string
};

const localeString = currency => price => price && `${currency} ${Number(price).toLocaleString()}`;

export default function Prices(props: Props) {
  const { discount, basePrice, grandTotal, currency, additionalCost, purchaseAmount } = props;

  const isDiscount = Number(discount) > 0;
  const withCurrency = localeString(currency);

  return (
    <div className="service-list price">
      <ul>
        {isDiscount && (
          <React.Fragment>
            <Span
              title="SubTotal"
              value={withCurrency(basePrice)}
              isHighlighted
            />
            <Span
              title="Discount"
              value={withCurrency(discount)}
              isHighlighted
            />
          </React.Fragment>
        )}
        <Span
          title="Total Amount"
          value={withCurrency(purchaseAmount)}
          isHighlighted
        />
        <Span
          title="Transaction Fee"
          value={withCurrency(additionalCost)}
          isHighlighted
        />
        <Span
          title="Grand Total"
          value={withCurrency(grandTotal)}
          isHighlighted
        />
      </ul>
    </div>
  );
}

Prices.defaultProps = {
  additionalCost: null,
}



// WEBPACK FOOTER //
// ./src/components/Prices/Prices.js